export type ClearAfter = 'never' | '30m' | '1h' | '4h' | 'today' | 'keep';

export const CLEAR_AFTER_OPTIONS: Array<{ value: Exclude<ClearAfter, 'keep'>; label: string }> = [
  { value: 'today', label: 'Today' },
  { value: '4h', label: '4 hours' },
  { value: '1h', label: '1 hour' },
  { value: '30m', label: '30 minutes' },
  { value: 'never', label: "Don't clear" },
];

/**
 * Converts a "clear after" choice into the absolute time sent to the server.
 * Computed on the client so "today" means the end of the user's local day.
 */
export function clearAfterToIso(choice: ClearAfter, current: string | null, now = new Date()): string | null {
  const minutes = { '30m': 30, '1h': 60, '4h': 240 } as const;
  switch (choice) {
    case 'never':
      return null;
    case 'keep':
      return current;
    case 'today': {
      const end = new Date(now);
      end.setHours(23, 59, 59, 0);
      return end.toISOString();
    }
    default:
      return new Date(now.getTime() + minutes[choice] * 60_000).toISOString();
  }
}

/** "Clears at 5:30 PM" / "Clears Tue 9:00 AM" for an existing expiry. */
export function describeExpiry(iso: string | null, now = new Date()): string | null {
  if (!iso) return null;
  const at = new Date(iso);
  const time = at.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  return at.toDateString() === now.toDateString() ? `Clears at ${time}` : `Clears ${at.toLocaleDateString(undefined, { weekday: 'short' })} ${time}`;
}
